import React from 'react';
import HsSelect from '../../Form/HsSelect';
import { strings } from '../../../assets/strings/all';

function HsSort(props) {
  const { common } = strings;
  const sortOptions = [
    { slug: 'recent', name: common.most_recent },
    // { slug: 'followed', name: 'Most Followed' },
    { slug: 'commented', name: common.most_comments },
  ];

  return (
    <>
      <HsSelect
        label={common.sort_by}
        placeholder={common.sort_by}
        options={[{ label: common.sort_by, options: sortOptions }]}
        // defaultIcon="icon-ico-hide"
        defaultValue={sortOptions[0]}
        onChange={props.onChange}
        isClearable={false}
        // value={caseData.visibilityStatus}
      />
    </>
  );
}

export default HsSort;
